export const SIDEBAR_TRANSITION_MS = 220;
